import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import 'jquery-ui/ui/widgets/draggable';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import SessionManager from '../routes/SessionManager';
import DropdownButton from './bootstrap4/DropdownButton';
import Loading from './Loading';
import Toastr from 'toastr';
import bootbox from 'bootbox';
import ZoneCard from './dashboard/ZoneCard';
import CommonUtils from '../util/CommonUtils';
import Modal from '../components/bootstrap4/Modal';
import SensorDetails from './SensorDetails';
import Input from './bootstrap4/Input';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

function PDFAnnotate(props) {

    let siteplan1 = props.siteplan;
    let zones1 = props.zones;
    let sensors1 = props.sensors;
    let refreshSitePlans = props.refresh;
    let isMount = useRef(true);
    let viewDropdown = [
        { value: "gateway", label: "Gateway" },
        { value: "sensor", label: "Sensor", disabled: sensors1.length === 0 }
    ];
    const getState = (props) => {
        isMount.current = true;
        let markerPositions = siteplan1.marker_positions;
        markerPositions = markerPositions ? JSON.parse(markerPositions) : [];

        let zoneMap1 = {};
        let activeZones = zones1.length > 0 ? zones1.filter((z) => {
            if (z.location_adminstatus === 'Up') {
                zoneMap1[z.location_id] = z;
                return true;
            } else {
                return false;
            }
        }) : [];
        let zoneProp = 'location_name';
        activeZones = activeZones.sort((a, b) => a[zoneProp] > b[zoneProp] ? 1 : a[zoneProp] < b[zoneProp] ? -1 : 0);
        if (markerPositions.length > 0)
            markerPositions = markerPositions.sort((a, b) => a.top - b.top);

        let sensors = sensors1.length > 0 ? sensors1 : [];
        sensors = sensors.sort((a, b) => a['s_id'] > b['s_id'] ? 1 : a['s_id'] < b['s_id'] ? -1 : 0);
        if (markerPositions.length > 0)
            markerPositions = markerPositions.sort((a, b) => a.top - b.top);

        if (isMount.current) {
            setZones(activeZones);
            setSensors(sensors);
            setViewType(viewDropdown[0].value);
            setSiteplan(siteplan1);
            setMarkerPosArrBkp([...markerPositions]);
            setMarkerPosArr(markerPositions);
            setNumPages(0);
            setCurrPage(1);
            setPdfLoaded(false);
            setZoneMap(zoneMap1);
        }
    }

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let timezone = user.site_selected.site_iana_timezone;
    let chartPlugin = [];
    let _data = {};

    const [zoneValidation, setZoneValidation] = useState(false);
    const [sensorValidation, setSensorValidation] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [viewType, setViewType] = useState('gateway');
    const [markerPosArrBkp, setMarkerPosArrBkp] = useState([]);
    const [markerPosArr, setMarkerPosArr] = useState([]);
    const [pdfLoaded, setPdfLoaded] = useState(false);
    const [selectedZone, setSelectedZone] = useState("");
    const [selectedSensor, setSelectedSensor] = useState("");
    const [numPages, setNumPages] = useState(0);
    const [zone_selected, setZone_selected] = useState("");
    const [sensor_selected, setSensor_selected] = useState("");
    const [errMsg, setErrMsg] = useState(null);
    const [zones, setZones] = useState([]);
    const [sensors, setSensors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sensorwiseChartData, setSensorwiseChartData] = useState({});
    const [siteplan, setSiteplan] = useState({});
    const [pdfWidth, setPdfWidth] = useState(0);
    const [currPage, setCurrPage] = useState(0);
    const [zoneMap, setZoneMap] = useState({});
    const [markerPos, setMarkerPos] = useState({ top: 0, left: 0 });
    const [offsetPos, setOffsetPos] = useState({ top: 0, left: 0 });
    const [isModify, setIsModify] = useState(false);
    const [sensors_info, setSensors_info] = useState([]);

    useEffect(() => {
        getState(props);
        setPdfWidth($('#pdf-doc-container').width());
        setSensors_info(props.sensors_info);
        return () => isMount.current = false;
    }, [props]);

    const toggleEditMode = () => {
        setEditMode(!editMode);
    }

    const cancelEditMode = () => {
        $('.siteplan-marker').removeClass('renaming-zone');
        hideAnnotatorModal();
        setMarkerPosArr(markerPosArrBkp);
        setEditMode(false);
    }

    const saveMarkerPositions = (toggleEdit = true) => {
        hideAnnotatorModal();

        if (editMode) {
            toggleEditMode();
        }
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.site_selected.customer_id,
            file_name: siteplan.file_name,
            marker_positions: JSON.stringify(markerPosArr)
        };

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/doc-vault/modify-siteplan',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then((res) => {
            if (res.status && res.status.code === 200) {
                Toastr.success('SitePlan Modified successfully !');
                setPdfLoaded(false);
                setTimeout(() => refreshSitePlans(), 2000);
            }
        });
    }

    const clearMarkerPositions = () => {
        hideAnnotatorModal();

        const filteredItem = viewType === 'gateway' ? 'location_id' : 's_id';
        var markerPosArr1 = markerPosArr.filter(item => Object.keys(item).indexOf(filteredItem) === -1);
        bootbox.confirm('Are you sure you want to clear all markers ?', function (isYes) {
            if (isYes) {
                setMarkerPosArr(markerPosArr1);
                setIsModify(true);
            }
        });
    }

    useEffect(() => {
        if (isModify && markerPosArr) {
            saveMarkerPositions();
        }
    }, [isModify]);

    const deleteMarkerPosition = (markerRec) => {
        let markerPosArr1 = [...markerPosArr];
        markerPosArr1 = markerPosArr.filter((rec) => rec.id !== markerRec.id);
        setMarkerPosArr(markerPosArr1);
        setSelectedSensor("");
        setSelectedZone("");
    }

    const onPDFLoad = (obj) => {
        if (pdfLoaded) {
            return;
        }

        let totalPages = obj.numPages;
        setTimeout(() => {
            getState(props);
            if ($('.react-pdf__Page__canvas').length > 0) {
                $('#annotator').css('height', $('.react-pdf__Page__canvas').height());
                $('#annotator').css('width', $('.react-pdf__Page__canvas').width());
                let offsetPos = { top: $('.react-pdf__Page__canvas').height(), left: $('.react-pdf__Page__canvas').width() };
                setNumPages(totalPages);
                setPdfLoaded(true);
                setOffsetPos(offsetPos);
            }
        }, 5000);
    }

    const onImageload = () => {
        setPdfLoaded(true);
        if (pdfLoaded) {
            return;
        }

        let offsetPos = { top: $('#site_img').height(), left: $('#site_img').width() };
        setOffsetPos(offsetPos);
    }

    const showNext = () => {
        setCurrPage(currPage + 1);
    }

    const showPrev = () => {
        setCurrPage(currPage - 1);
    }

    const annotate = (e) => {
        if ($(e.target).hasClass('btn-rename-location') ||
            $(e.target).hasClass('txt-rename-location') ||
            $(e.target).hasClass('cancel-rename-location') ||
            $(e.target).hasClass('btn-rename-sensor') ||
            $(e.target).hasClass('txt-rename-sensor') ||
            $(e.target).hasClass('cancel-rename-sensor') ||
            $(e.target).hasClass('btn-rename-headless') ||
            $(e.target).hasClass('txt-rename-headless') ||
            $(e.target).hasClass('cancel-rename-headless') ||
            $(e.target).hasClass('fa-edit') ||
            $(e.target).hasClass('fa-save') ||
            $(e.target).hasClass('fa-trash-alt') ||
            $(e.target).hasClass('dropdown-item'))
            return;

        if (!editMode)
            return

        if ($('#annotator-modal').hasClass('editMode'))
            return;

        let c = $('#pdf-highlighter-container').offset();
        let markerPos = { top: (e.pageY - c.top), left: (e.pageX - c.left) };

        $('#annotator-modal').removeClass('hide').addClass('editMode');
        $('#annotator').css('background', '#bcbcbc63');

        $('#annotator-modal').css('top', (markerPos.top) + 'px');
        $('#annotator-modal').css('left', (markerPos.left) + 'px');
        setMarkerPos(markerPos);
    }

    const hideAnnotatorModal = (e) => {
        if (e)
            e.stopPropagation();
        $('#annotator').css('background', 'none');
        $('#annotator-modal').removeClass('editMode').addClass('hide');

    }

    const saveAnnotatorModal = (e) => {
        e.stopPropagation();
        Toastr.options = {
            "preventDuplicates": true
        };
        if (zoneValidation === false && (viewType === 'gateway')) {
            Toastr.error("Please Select Gateway");
            return
        }
        if (sensorValidation === false && (viewType === 'sensor')) {
            Toastr.error("Please Select Sensor")
            return
        };
        let m = { ...markerPos };
        let o = { ...offsetPos };
        let markerRec;
        if (zone_selected && viewType === 'gateway') {
            markerRec = { id: Math.random(), page: currPage, left: m.left / o.left, top: m.top / o.top, location_id: zone_selected.location_id };
        }
        if (sensor_selected && viewType === 'sensor') {
            markerRec = { id: Math.random(), page: currPage, left: m.left / o.left, top: m.top / o.top, s_id: sensor_selected.s_id };
        }
        $('#annotator').css('background', 'none');
        $('#annotator-modal').removeClass('editMode').addClass('hide');
        let markerRecs = [...markerPosArr];
        markerRecs.push(markerRec);
        setMarkerPosArr(markerRecs);
        setZoneValidation(false);
        setSensorValidation(false);
    }

    const modifyMarker = (id, obj) => {
        let markerRecs = [...markerPosArr];
        for (let m of markerRecs) {
            if (m.location_id === id || m.s_id === id) {
                for (let k in obj) {
                    m[k] = obj[k];
                }
            }
        }
        setMarkerPosArr(markerRecs);
    }

    const onSiteMarkerDragStop = (e) => {
        let c = $('#pdf-highlighter-container').offset();
        var container = siteplan.signed_url.includes(".pdf") ? $('#pdf-doc-container') : $('#site_img');
        let bounds = [c.top, c.left + container.width(), c.top + container.height(), c.left];
        let o = { ...offsetPos };
        if (e.pageY < bounds[0] || e.pageY > bounds[2]) {
            return;
        }
        if (e.pageX < bounds[3] || e.pageX > bounds[1]) {
            return;
        }

        let markerPos = { top: ((e.pageY - c.top) - 25) / o.top, left: ((e.pageX - c.left)) / o.left };
        let att = viewType === 'sensor' ? 's_id' : 'location_id';
        let location_id = $(e.target).find('.siteplan-' + viewType + '-handle').attr(att);
        modifyMarker(location_id, markerPos);
    }

    const onSelected = (obj) => {
        if (viewType === 'gateway') {
            setZone_selected(obj);
            setSelectedZone(obj.location_id);
            setZoneValidation(true);
            setErrMsg(null);
        } else {
            setSensor_selected(obj);
            setSelectedSensor(obj.s_id);
            setSensorValidation(true);
            setErrMsg(null);
        }
    }

    const toggleZoneCard = (id, show = 0) => {
        if (show === 1) {
            $('#popover-content-' + id).removeClass('hide');
            $('#popover-content-' + id).css({ top: -($('#popover-content-' + id).height()) + 'px' })
        } else {
            $('#popover-content-' + id).addClass('hide');
        }
    }

    const renameLocation = (loc_id) => {
        var renamed = document.getElementById('Text' + loc_id).value;
        if (renamed === zoneMap[loc_id].location_name) {
            $("#Btn" + loc_id).addClass('disabled-checkbox');
        } else {
            $("#Btn" + loc_id).removeClass('disabled-checkbox');
        }
    }

    const editLocation = (e, markerRec) => {
        $("#Btn" + markerRec.location_id).addClass('disabled-checkbox');
        let editOrSaveBtn = $(e.currentTarget).find('i')[0];
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        if ($(editOrSaveBtn).hasClass('fa-edit')) {
            $(sitePlanMarker).addClass('renaming-zone');
            $(sitePlanMarker).find('.txt-rename-location').removeClass('hide');
            $(sitePlanMarker).find('.cancel-rename-location').removeClass('hide');
            $(sitePlanMarker).find('.txt-rename-location').focus();
            $(editOrSaveBtn).removeClass('fa-edit').addClass('fa-save');
        } else {
            let locationName = $(sitePlanMarker).find('.txt-rename-location').val();
            const element = $(sitePlanMarker).find('.txt-rename-location');
            const lIsValidText = $(element).attr("isvalidtext");
            if (!(lIsValidText === "true" || lIsValidText === true)) {
                const lErrorText = $(element).attr("invaliderrormsg");
                const position = Toastr.options.positionClass
                Toastr.options.positionClass = 'toast-top-center';
                Toastr.error(lErrorText);
                Toastr.options.positionClass = position;
                return;
            }
            if (locationName.trim().length === 0) {
                Toastr.error("Zone name should not be empty");
                return
            }
            if (user.zones.find(z => z.location_name.trim() === locationName.trim())) {
                Toastr.error(`"${locationName}" already exists`);
                return
            }
            bootbox.dialog({ html: true, message: '<span className="text-primary"><i className="fa fa-spin fa-lg fa-circle-notch mr-2"></i> Saving Location Details</span>', closeButton: false });
            var data = {
                form_input: { site_id: user.site_selected.site_id, location_id: markerRec.location_id, location_name: locationName },
                customer_id: user.site_selected.customer_id,
                site_id: user.site_selected.site_id,
                user_login: user.user_login,
                user_token: user.user_token
            };

            $.ajax({
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then((res) => {
                setTimeout(() => bootbox.hideAll(), 2000);
                if (res.status && res.status.code === 200) {
                    Toastr.success('Location renamed successfully !');

                    var sessionManager = new SessionManager();
                    let _user = JSON.parse(JSON.stringify(sessionManager.readCookie('user')));
                    let zones1 = _user.zones;
                    for (let z of zones1) {
                        if (z.location_id === markerRec.location_id) {
                            z.location_name = locationName;
                            zoneMap[z.location_id].location_name = locationName;
                            break;
                        }
                    }
                    sessionManager.storeCookie('user', _user);
                    $(editOrSaveBtn).removeClass('fa-save').addClass('fa-edit');
                    $(sitePlanMarker).find('.cancel-rename-location').addClass('hide');
                    $(sitePlanMarker).find('.txt-rename-location').addClass('hide');
                    $(sitePlanMarker).removeClass('renaming-zone');
                    $("#Btn" + markerRec.location_id).removeClass('disabled-checkbox');
                    setZones(_user.zones);
                }
            });
        }

    }

    const cancelRenameLocation = (e, markerRec) => {
        e.stopPropagation();
        let cancelBtn = $(e.currentTarget);
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        let editOrSaveBtn = $(sitePlanMarker).find('.btn-rename-location').find('i')[0];
        $(sitePlanMarker).removeClass('renaming-zone');
        $(editOrSaveBtn).toggleClass('fa-edit fa-save');
        $(sitePlanMarker).find('.txt-rename-location').addClass('hide');
        $(cancelBtn).addClass('hide');
        $("#Btn" + markerRec.location_id).removeClass('disabled-checkbox');
    }

    const getSensorTitle = (id) => {
        var obj = sensors.find(s => s.s_id === id);
        if (obj) {
            let name = obj.name || obj.serial_number;
            return name;
        }
    }

    const renameSensor = (sensor_id) => {
        var renamed = document.getElementById('Text' + sensor_id).value;
        var sensors1 = [...sensors]
        if (renamed === sensors1.find(s => s.s_id === sensor_id).name) {
            $("#Btn" + sensor_id).addClass('disabled-checkbox');
        } else {
            $("#Btn" + sensor_id).removeClass('disabled-checkbox');
        }
    }

    const editSensor = (e, markerRec) => {
        hideAnnotatorModal();
        $("#Btn" + markerRec.s_id).addClass('disabled-checkbox');
        let editOrSaveBtn = $(e.currentTarget).find('i')[0];
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        if ($(editOrSaveBtn).hasClass('fa-edit')) {
            $(sitePlanMarker).addClass('renaming-sensor');
            $(sitePlanMarker).find('.txt-rename-sensor').removeClass('hide');
            $(sitePlanMarker).find('.cancel-rename-sensor').removeClass('hide');
            $(sitePlanMarker).find('.txt-rename-sensor').focus();
            $(editOrSaveBtn).removeClass('fa-edit').addClass('fa-save');
        } else {
            let sensorName = $(sitePlanMarker).find('.txt-rename-sensor').val();
            const element = $(sitePlanMarker).find('.txt-rename-sensor');
            const lIsValidText = $(element).attr("isvalidtext");
            if (!(lIsValidText === "true" || lIsValidText === true)) {
                const lErrorText = $(element).attr("invaliderrormsg");
                const position = Toastr.options.positionClass
                Toastr.options.positionClass = 'toast-top-center';
                Toastr.error(lErrorText);
                Toastr.options.positionClass = position;
                return;
            }
            if (sensorName.trim().length === 0) {
                Toastr.error("Sensor name should not be empty");
                return
            }
            if (sensors.find(s => s.name.trim() === sensorName.trim())) {
                Toastr.error(`"${sensorName}" already exists`);
                return
            }
            bootbox.dialog({ html: true, message: '<span className="text-primary"><i className="fa fa-spin fa-lg fa-circle-notch mr-2"></i> Saving Sensor Details</span>', closeButton: false });
            var sensor_type = sensors.find(s => s.s_id === markerRec.s_id).sensor_type;
            var sensors1 = [...sensors];
            sensors1.find(s => s.s_id === markerRec.s_id).name = sensorName;
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor/modify',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify({
                        form_input: {
                            sensor_type: sensor_type,
                            sensor_id: markerRec.s_id,
                            sensor_name: sensorName
                        },
                        "user_login": user.user_login,
                        "user_token": user.user_token,
                        "user_type": "user"
                    })
                }
            ).then(
                (res) => {
                    setTimeout(() => bootbox.hideAll(), 2000);
                    if (res.status && res.status.code === 200) {
                        Toastr.success('Sensor renamed successfully !');
                    }

                    $(editOrSaveBtn).removeClass('fa-save').addClass('fa-edit');
                    $(sitePlanMarker).find('.cancel-rename-sensor').addClass('hide');
                    $(sitePlanMarker).find('.txt-rename-sensor').addClass('hide');
                    $(sitePlanMarker).removeClass('renaming-sensor');
                    $("#Btn" + markerRec.s_id).removeClass('disabled-checkbox');
                    setSensors(sensors);
                }
            )
        }
    }

    const cancelRenameSensor = (e, markerRec) => {
        e.stopPropagation();
        let cancelBtn = $(e.currentTarget);
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        let editOrSaveBtn = $(sitePlanMarker).find('.btn-rename-sensor').find('i')[0];
        $(sitePlanMarker).removeClass('renaming-sensor');
        $(editOrSaveBtn).toggleClass('fa-edit fa-save');
        $(sitePlanMarker).find('.txt-rename-sensor').addClass('hide');
        $(cancelBtn).addClass('hide');
        $("#Btn" + markerRec.s_id).removeClass('disabled-checkbox');
    }

    const renameHeadlessGateway = (sensor_id) => {
        var renamed = document.getElementById('Text' + sensor_id).value;
        var sensors1 = [...sensors]
        if (renamed === sensors1.find(s => s.s_id === sensor_id).name) {
            $("#Btn" + sensor_id).addClass('disabled-checkbox');
        } else {
            $("#Btn" + sensor_id).removeClass('disabled-checkbox');
        }
    }

    const editHeadlessGateway = (e, markerRec) => {
        hideAnnotatorModal();

        $("#Btn" + markerRec.s_id).addClass('disabled-checkbox');
        let editOrSaveBtn = $(e.currentTarget).find('i')[0];
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        if ($(editOrSaveBtn).hasClass('fa-edit')) {
            $(sitePlanMarker).addClass('renaming-headless');
            $(sitePlanMarker).find('.txt-rename-headless').removeClass('hide');
            $(sitePlanMarker).find('.cancel-rename-headless').removeClass('hide');
            $(sitePlanMarker).find('.txt-rename-headless').focus();
            $(editOrSaveBtn).removeClass('fa-edit').addClass('fa-save');
        } else {
            let headlessName = $(sitePlanMarker).find('.txt-rename-headless').val();
            const element = $(sitePlanMarker).find('.txt-rename-headless');
            const lIsValidText = $(element).attr("isvalidtext");
            if (!(lIsValidText === "true" || lIsValidText === true)) {
                const lErrorText = $(element).attr("invaliderrormsg");
                const position = Toastr.options.positionClass
                Toastr.options.positionClass = 'toast-top-center';
                Toastr.error(lErrorText);
                Toastr.options.positionClass = position;
                return;
            }
            if (headlessName.trim().length === 0) {
                Toastr.error("Gateway Sensor name should not be empty");
                return
            }
            if (sensors.find(s => s.name.trim() === headlessName.trim())) {
                Toastr.error(`"${headlessName}" already exists`);
                return
            }

            var sensors1 = [...sensors];
            sensors1.find(s => s.s_id === markerRec.s_id).name = headlessName;
            var data = {
                form_input: {
                    site_id: user.site_selected.site_id,
                    location_id: sensors.find(s => s.s_id === markerRec.s_id).location_id,
                    location_name: headlessName
                },
                customer_id: user.site_selected.customer_id,
                site_id: user.site_selected.site_id,
                user_login: user.user_login,
                user_token: user.user_token
            };
            $.ajax({
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then((res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success('Gateway Sensor renamed successfully !');

                    $(editOrSaveBtn).removeClass('fa-save').addClass('fa-edit');
                    $(sitePlanMarker).find('.cancel-rename-headless').addClass('hide');
                    $(sitePlanMarker).find('.txt-rename-headless').addClass('hide');
                    $(sitePlanMarker).removeClass('renaming-headless');
                    $("#Btn" + markerRec.s_id).removeClass('disabled-checkbox');
                    setSensors(sensors);
                }
            });
        }
    }

    const cancelRenameHeadlessGateway = (e, markerRec) => {
        e.stopPropagation();
        let cancelBtn = $(e.currentTarget);
        let sitePlanMarker = $(e.currentTarget).closest('.siteplan-marker');
        let editOrSaveBtn = $(sitePlanMarker).find('.btn-rename-headless').find('i')[0];
        $(sitePlanMarker).removeClass('renaming-headless');
        $(editOrSaveBtn).toggleClass('fa-edit fa-save');
        $(sitePlanMarker).find('.txt-rename-headless').addClass('hide');
        $(cancelBtn).addClass('hide');
        $("#Btn" + markerRec.s_id).removeClass('disabled-checkbox');
    }

    const viewHandleChange = (key) => {
        setViewType(key.value);
    }

    useEffect(() => {
        if (viewType === "sensor") {
            fetchSensorDetails();
        }
    }, [viewType]);

    const fetchSensorDetails = () => {
        setLoading(true);
        var payload = {
            customer_id: user.site_selected.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            timezone: timezone
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/environmental-data',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {

                    chartPlugin = [{
                        afterDraw: (chart) => {
                            let datasetSize = chart.data.datasets.length;
                            if (datasetSize > 0) {

                                let lastDataSet = chart.data.datasets[datasetSize - 1];
                                // We might get with out no data dataset or one with empty data set.
                                if (lastDataSet.label === 'NO DATA' && lastDataSet.noData) {
                                    var ctx = chart.chart.ctx;
                                    ctx.save();
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "bold 14px sans-serif";
                                    ctx.fillStyle = "rgba(0,0,0,1)";
                                    ctx.fillText('No data available ...', chart.chart.width / 2, chart.chart.height / 2);
                                    ctx.restore();
                                }
                            }
                        }
                    }];

                    let colors = ['#48C9B0', '#F5B041', '#3498DB', '#AF7AC5', '#21B345', '#42d1f4'];
                    var envUnitsMap = {
                        'temperature': 'F',
                        'humidity': '%',
                        'co': 'ppm',
                        'co2': 'ppm',
                        'voc': 'ppb',
                        'leak': '',
                        'flow': 'Gallons'
                    };
                    var data = res.data;
                    var dates = [];

                    if (data && data.length > 0) {
                        var startDate = payload.start_date;
                        while (startDate <= payload.end_date) {
                            dates.push(moment(startDate, 'YYYY-MM-DD').format('MMM DD'));
                            startDate = moment(startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        }
                    }

                    var sensorwise_env_data = {};

                    for (let d of data) {
                        if (d.sensor_id === 'voc')
                            continue;

                        if (d.sensor_name === d.device_name)
                            continue;

                        if (!sensorwise_env_data[d.sensor_name])
                            sensorwise_env_data[d.sensor_name] = {};

                        if (!sensorwise_env_data[d.sensor_name][d.sensor_id]) {
                            var date = moment(payload.start_date, 'YYYY-MM-DD').format('MMM DD')
                            var dateMapDefaults = {};
                            dateMapDefaults[date] = [{ event_type: 'dummy', event_value: null, event_ts: date + ', 00:00' }];
                            sensorwise_env_data[d.sensor_name][d.sensor_id] = dateMapDefaults;
                        }

                        let mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
                        let hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm');
                        if (!sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd]) {
                            sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd] = [];
                        }
                        let event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
                        sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd].push({ event_loc: d.location_id, event_value: event_val, event_ts: mmmdd + ', ' + hhmm });
                    }

                    let sensorChartMap = {};

                    for (let sensor_name_key in sensorwise_env_data) {
                        let sensorwise_data = {};
                        let sensorIds = Object.keys(sensorwise_env_data[sensor_name_key]);
                        let envParamsObj = {};

                        for (let x of sensorIds) {
                            envParamsObj[x] = null;
                        }

                        for (let sensor_id_key in sensorwise_env_data[sensor_name_key]) {
                            for (let date_key in sensorwise_env_data[sensor_name_key][sensor_id_key]) {
                                for (let date_key_rec of sensorwise_env_data[sensor_name_key][sensor_id_key][date_key]) {
                                    if (date_key_rec.event_type === 'dummy' && sensorwise_env_data[sensor_name_key][sensor_id_key][date_key].length > 1) {
                                        continue;
                                    }
                                    if (!sensorwise_data[date_key_rec.event_ts]) {
                                        sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                                    }
                                    sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                                }
                            }
                        }

                        let sensor_info = [...sensors_info];
                        let sensors = []
                        for (let sensor of sensor_info) {
                            let s = { ...sensor };
                            s.sensor_name_key = s.sensor_type + "_" + s.sensor_id
                            sensors.push(s);
                        }
                        setSensors_info(sensors);
                        let sensor_serial_number = sensors.find((s) => s.sensor_name_key === sensor_name_key) && sensors.find((s) => s.sensor_name_key === sensor_name_key).sensor_serial_number;

                        sensorChartMap[sensor_name_key] = {
                            options: {
                                title: {
                                    fontColor: 'rgba(0, 0, 0)',
                                    display: true,
                                    text: "Sensor " + sensor_serial_number //"Sensor " + sensor_serial_number
                                },
                                legend: {
                                    display: true
                                },
                                tooltips: {
                                    mode: 'single',
                                    intersect: false,
                                    custom: function (tooltip) {
                                        if (!tooltip) return;
                                        tooltip.displayColors = false;
                                    },
                                    callbacks: {
                                        title: function (tArr, d) {
                                            if (tArr && tArr.length > 0) {
                                                let t = tArr[0];
                                                if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                                                    return '';
                                                } else {
                                                    let labelData = d.datasets[t.datasetIndex].labelData;
                                                    let val = t.yLabel + '' + labelData.units;
                                                    return labelData.label + '  ' + val;
                                                }
                                            }
                                        },
                                        label: function (t, d) {
                                            if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                                                return 'No data found...';
                                            } else {
                                                return t.xLabel;
                                            }
                                        },
                                        labelTextColor: function (t, chart) {
                                            let isNoDataSet = _data.datasets && _data.datasets[t.datasetIndex].label === 'NO DATA';
                                            return isNoDataSet ? '#FFFFFF' : colors[t.datasetIndex];
                                        }
                                    }
                                },
                                scales: {
                                    xAxes: [{
                                        categoryPercentage: 1.0,
                                        barPercentage: 1.0,
                                        ticks: {
                                            autoSkip: true
                                        },
                                        display: true,
                                        gridLines: {
                                            display: true
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Hour',
                                            fontColor: 'orange'
                                        }
                                    }],
                                    yAxes: []
                                },
                                maintainAspectRatio: false
                            },
                            labels: [],
                            datasets: []
                        };

                        let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
                        sensorChartMap[sensor_name_key].labels = labelsDateTimeSorted;
                        let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));

                        let idx = 0;
                        for (let envParam in envParamWiseData) {
                            let yKey = sensor_name_key + '-' + envParam;
                            sensorChartMap[sensor_name_key].options.scales.yAxes.push(
                                {
                                    display: true,
                                    gridLines: {
                                        display: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "",
                                        fontColor: 'orange'
                                    },
                                    id: yKey,
                                    position: idx > 0 ? 'right' : 'left',
                                    ticks: {
                                        fontColor: colors[idx]
                                    },
                                    beforeBuildTicks: function (e) {
                                        e.options.display = (e.min !== -1);
                                    }
                                }
                            );

                            let envParamData = [];
                            for (let date of sensorChartMap[sensor_name_key].labels) {
                                envParamData.push(sensorwise_data[date][envParam]);
                            }

                            let minmax = filter_sort([...envParamData]);
                            sensorChartMap[sensor_name_key].datasets.push(
                                {
                                    type: 'line',
                                    labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                                    label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                                    backgroundColor: 'rgba(0,0,0,0)',
                                    pointHoverBorderColor: colors[idx],
                                    pointBackgroundColor: colors[idx],
                                    borderColor: colors[idx],
                                    hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                                    data: envParamData,
                                    yAxisID: yKey,
                                    pointRadius: 2
                                }
                            );
                            idx++;
                        }
                        addNoDataDataSet(sensorChartMap[sensor_name_key]);
                    }

                    setSensorwiseChartData(sensorChartMap);
                    setLoading(false);
                }
            })
    }

    const addNoDataDataSet = (chart) => {
        let dataSetsSize = chart.datasets.length;
        let maxVal = 0;
        let dataFoundPoints = 0;
        let missingData = chart.datasets[0].data.map((v, idx) => {
            let foundVal = false;
            for (let i = 0; i < dataSetsSize; i++) {
                if (chart.datasets[i].data[idx]) {
                    if (chart.datasets[i].data[idx] > maxVal) {
                        maxVal = chart.datasets[i].data[idx];
                    }
                    foundVal = true;
                }
            }
            if (foundVal)
                dataFoundPoints++;
            return foundVal ? 0 : 1;
        });

        if (maxVal === 0 && dataFoundPoints === 0) {
            maxVal = 100;
        }

        for (let i = 0; i < missingData.length; i++) {
            if (missingData[i] === 1)
                missingData[i] = maxVal;
        }

        let dataLen = missingData.length;
        if (dataFoundPoints !== dataLen) {
            let yKey = new Date().getMilliseconds();
            let newDataSet = {
                noData: (dataFoundPoints === 0),
                type: 'bar',
                label: 'NO DATA',
                backgroundColor: '#dedede',
                borderColor: '#dedede',
                borderWidth: 0,
                hoverBackgroundColor: '#dedede',
                hoverBorderColor: '#dedede',
                data: missingData,
                yAxisID: yKey
            };
            chart.datasets.push(newDataSet);
            let ticksObj = { display: false }
            if (dataFoundPoints === 0) {
                ticksObj = {
                    display: false,
                    beginAtZero: true,
                    steps: 10,
                    stepValue: 10,
                    max: 100
                };
            };
            chart.options.scales.yAxes.push({
                display: true,
                gridLines: {
                    display: false
                },
                scaleLabel: {
                    display: true,
                    labelString: "",
                    fontColor: 'orange'
                },
                ticks: ticksObj,
                id: yKey,
                position: 'right',
                beforeBuildTicks: function (e) {
                    e.options.display = (e.min !== -1);
                }
            });
        }
    }

    const filter_sort = (test_array) => {
        var index = -1,
            arr_length = test_array ? test_array.length : 0,
            resIndex = -1,
            result = [];

        while (++index < arr_length) {
            var value = test_array[index];

            if (value !== null) {
                result[++resIndex] = parseFloat(value);
            }
        }

        if (result.length > 0) {
            result = result.sort((a, b) => a - b);
        }

        return result.length === 0 ? ['-'] : result;
    }

    const capitalize = (s) => {
        return s.toUpperCase()
    }

    var markerPosArr1 = [...markerPosArr];
    const filteredItem = viewType === 'gateway' ? 'location_id' : 's_id';
    markerPosArr1 = markerPosArr1.filter(item => Object.keys(item).indexOf(filteredItem) !== -1);
    let markerLocations = [];
    for (let ml of markerPosArr)
        markerLocations.push(ml[filteredItem])

    $('.bs-tooltip-top').remove();
    if (editMode) {
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
            var containment = siteplan.signed_url.includes(".pdf") ? '#pdf-doc-container' : '#site_img';
            $('.siteplan-marker').draggable({ containment: containment, handle: 'span', stop: onSiteMarkerDragStop });
        }, 1000);
    }
    let m1 = (moment.utc().add(-20, 'minutes')).unix();
    return (
        <React.Fragment>
            <div id="annotator" onClick={annotate} style={{ position: "absolute", top: "15px", width: "100%", background: "none", zIndex: 890 }}>
                <div id='annotator-modal' className="hide" style={{ position: 'absolute', zIndex: 999, textAlign: 'center', background: "#E3E4E5", borderRadius: "4px" }}>
                    <div className="p-2">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-inline">
                                            <button className="btn btn-sm btn-primary py-custom border-rounded-0 border-rounded-l">
                                                <i className="fa fa-lg fa-map-marker-alt mx-1"></i>
                                            </button>
                                            <DropdownButton
                                                className="btn btn-sm dropdown-toggle btn-radius-left-0 text-dark py-custom"
                                                onOptionClick={onSelected}
                                                default={viewType === "gateway" ? (zones.length === 0 ? "No Zones Found" : "Choose Zone") : (sensors.length === 0 ? <Loading transparent={true}> Fetching Sensor</Loading> : "Choose Sensor")}
                                                selected={viewType === "gateway" ? selectedZone : selectedSensor}
                                                opts={viewType === "gateway" ? zones.filter((z) => markerLocations.indexOf(z.location_id) === -1) : sensors.filter((s) => markerLocations.indexOf(s.s_id) === -1)}
                                                field_attr={viewType === "gateway" ? 'location_id' : 's_id'}
                                                value_attr={viewType === "gateway" ? 'location_name' : 'name||serial_number'} />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="text-center bg-light p-2 border-rounded">
                        <button className="btn btn-sm btn-default" onClick={hideAnnotatorModal}>Close</button>
                        <button className="btn btn-sm btn-primary" onClick={saveAnnotatorModal}>Save</button>
                    </div>
                    {errMsg && <div style={{ color: 'red' }}>{errMsg}</div>}
                </div>
                {pdfLoaded && markerPosArr1 && markerPosArr1.filter((x) => x.page === currPage).map((markerRec, i) => {
                    let top = parseFloat(markerRec.top) * parseFloat(offsetPos.top);
                    let left = parseFloat(markerRec.left) * parseFloat(offsetPos.left);
                    var sensorChartData = {};
                    const sensorKey = sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).sensor_type + '_' + markerRec.s_id;
                    sensorChartData[sensorKey] = sensorwiseChartData && sensorwiseChartData[sensorKey] ? sensorwiseChartData[sensorKey] : {};
                    return zoneMap[markerRec.location_id] || viewType === 'sensor' ?
                        <div key={'marker_' + viewType + '_' + i} style={{ top: top + 'px', left: left + 'px' }} className="siteplan-marker btn-group">
                            {!editMode && viewType === 'gateway' &&
                                <React.Fragment>
                                    <div id={'popover-content-' + markerRec.location_id} data-trigger="focus" className="hide zone-popover" style={{ top: '0px', left: '0px', position: 'absolute', width: '320px', zIndex: 1050 }}>
                                        <ZoneCard zone={zoneMap[markerRec.location_id]} site={user.site_selected}></ZoneCard>
                                    </div>
                                    <a
                                        onMouseOver={(e) => { toggleZoneCard(markerRec.location_id, 1); }}
                                        onMouseOut={(e) => { toggleZoneCard(markerRec.location_id, 0); }}
                                        onClick={(e) => { toggleZoneCard(markerRec.location_id, 0); }}
                                        location_id={markerRec.location_id}
                                        className={"btn btn-sm btn-marker zone-popover " + zoneMap[markerRec.location_id].location_operstatus}
                                        href={'/dashboard/zone-history?siteplan-ref=' + markerRec.location_id}
                                    >
                                        {zoneMap[markerRec.location_id].location_name}
                                    </a>
                                </React.Fragment>
                            }
                            {!editMode && viewType === "sensor" &&
                                <React.Fragment>
                                    {sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).device_type === 'sensor' &&
                                        <div id={'popover-content-' + markerRec.s_id} className="hide zone-popover" style={{ top: '0px', left: '0px', position: 'absolute', width: '320px', zIndex: 1050 }}>
                                            <div className="card my-2 bg-shadow" style={{ height: '250px', width: '100%', marginTop: '0px', marginBottom: '20px' }}>
                                                {loading ? (<div className="m-2"><Loading transparent={true}>Loading...</Loading></div>) :
                                                    (sensorChartData[sensorKey].datasets && sensorChartData[sensorKey].datasets.length > 0 ?
                                                        <React.Fragment>
                                                            <Bar
                                                                plugins={chartPlugin}
                                                                style={{ position: "relative" }}
                                                                data={sensorChartData[sensorKey]}
                                                                height={350}
                                                                options={sensorChartData[sensorKey].options}
                                                            />
                                                        </React.Fragment> :
                                                        <div style={{ lineHeight: '50px', textAlign: 'center', width: '100%', marginTop: '20px' }}>
                                                            <span>No data found ...</span>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    }
                                    {sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).device_type === 'sensor' ?
                                        <div
                                            onMouseOver={(e) => { toggleZoneCard(markerRec.s_id, 1); }}
                                            onMouseOut={(e) => { toggleZoneCard(markerRec.s_id, 0); }}
                                            className={m1 <= sensors.find(s => s.s_id === markerRec.s_id).sensor_dev_timestamp ? "btn btn-sm btn-marker Connected" : "btn btn-sm btn-marker Disconnected"}
                                        >
                                            <Modal
                                                id="sensorDetails"
                                                ref={React.createRef()}
                                                title={<span>{sensors.find(s => s.s_id === markerRec.s_id).device_type === 'Gateway' && <i className="fas fa-broadcast-tower text-success"></i>} {getSensorTitle(markerRec.s_id)}</span>}
                                                size="modal-lg"
                                            >
                                                <SensorDetails
                                                    sensorKey={sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).sensor_type + '_' + markerRec.s_id}
                                                    sensor_serial_number={sensors_info.find(s => s.sensor_id === markerRec.s_id) && sensors_info.find(s => s.sensor_id === markerRec.s_id).sensor_serial_number}
                                                    sensor_name={sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).name}
                                                />
                                            </Modal>
                                        </div> :
                                        <div
                                            onMouseOver={(e) => { toggleZoneCard(markerRec.s_id, 1); }}
                                            onMouseOut={(e) => { toggleZoneCard(markerRec.s_id, 0); }}
                                            className="btn btn-sm btn-marker-headless"
                                            style={{ cursor: "auto" }}
                                        >
                                            {sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).device_type === 'Gateway' && sensors.find(s => s.s_id === markerRec.s_id).device_operstatus === 'Connected' ? <i className="fas fa-broadcast-tower text-success"></i> : <i className="fas fa-broadcast-tower text-danger"></i>} {getSensorTitle(markerRec.s_id)}
                                        </div>
                                    }
                                </React.Fragment>
                            }
                            {editMode && viewType === 'gateway' &&
                                <React.Fragment>
                                    <span className="btn btn-sm btn-white siteplan-gateway-handle hide-while-rename" location_id={markerRec.location_id}><i className="fa fa-arrows-alt"></i></span>
                                    <DropdownButton
                                        className="btn btn-sm dropdown-toggle btn-radius-left-0 text-dark hide-while-rename"
                                        onOptionClick={(z) => modifyMarker(markerRec.location_id, { location_id: z.location_id, location_name: z.location_name })}
                                        default={zones.length === 0 ? <Loading> Fetching Zones</Loading> : "Choose Zone"}
                                        selected={markerRec.location_id}
                                        opts={zones.filter((z) => z.location_id === markerRec.location_id || markerLocations.indexOf(z.location_id) === -1)}
                                        field_attr='location_id'
                                        value_attr='location_name' />
                                    <Input id={'Text' + markerRec.location_id} onChange={() => renameLocation(markerRec.location_id)} className="form-control hide txt-rename-location" type="text" defaultValue={zoneMap[markerRec.location_id].location_name} autoComplete="off" />
                                    <button id={'Btn' + markerRec.location_id} onClick={(e) => editLocation(e, markerRec)} className="btn btn-sm btn-primary btn-rename-location" disabled={false}><i className="fa fa-edit mx-1"></i></button>
                                    <button onClick={(e) => cancelRenameLocation(e, markerRec)} className="btn btn-sm btn-warning cancel-rename-location hide btn-rounded-right"><i className="fa fa-arrow-right"></i></button>
                                    <button onClick={() => deleteMarkerPosition(markerRec)} className="btn btn-sm btn-danger hide-while-rename"><i className="fa fa-trash-alt mx-1"></i></button>
                                </React.Fragment>
                            }
                            {editMode && viewType === 'sensor' &&
                                <React.Fragment>
                                    <span className="btn btn-sm btn-white siteplan-sensor-handle hide-while-rename" s_id={markerRec.s_id}><i className="fa fa-arrows-alt"></i></span>
                                    <DropdownButton
                                        className="btn btn-sm dropdown-toggle btn-radius-left-0 text-dark hide-while-rename"
                                        onOptionClick={(s) => modifyMarker(markerRec.s_id, { s_id: s.s_id, sensor_serial_number: s.sensor_serial_number })}
                                        default={sensors.length === 0 ? <Loading> Fetching Sensors</Loading> : "Choose Sensor"}
                                        selected={markerRec.s_id}
                                        opts={sensors.filter((s) => s.s_id === markerRec.s_id || markerLocations.indexOf(s.s_id) === -1)}
                                        field_attr='s_id'
                                        value_attr='name||serial_number'
                                    />
                                    {sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).device_type === 'sensor' && <React.Fragment>
                                        <Input id={'Text' + markerRec.s_id} onChange={() => renameSensor(markerRec.s_id)} className="form-control hide txt-rename-sensor" type="text" defaultValue={sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).name} autoComplete="off" />
                                        <button id={'Btn' + markerRec.s_id} onClick={(e) => editSensor(e, markerRec)} className="btn btn-sm btn-primary btn-rename-sensor" disabled={false}><i className="fa fa-edit mx-1"></i></button>
                                        <button onClick={(e) => cancelRenameSensor(e, markerRec)} className="btn btn-sm btn-warning cancel-rename-sensor hide btn-rounded-right"><i className="fa fa-arrow-right"></i></button>
                                        <button onClick={() => deleteMarkerPosition(markerRec)} className="btn btn-sm btn-danger hide-while-rename"><i className="fa fa-trash-alt mx-1"></i></button>
                                    </React.Fragment>}
                                    {sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).device_type === 'Gateway' && <React.Fragment>
                                        <Input id={'Text' + markerRec.s_id} onChange={() => renameHeadlessGateway(markerRec.s_id)} className="form-control hide txt-rename-headless" type="text" defaultValue={sensors.find(s => s.s_id === markerRec.s_id) && sensors.find(s => s.s_id === markerRec.s_id).name} autoComplete="off" />
                                        <button id={'Btn' + markerRec.s_id} onClick={(e) => editHeadlessGateway(e, markerRec)} className="btn btn-sm btn-primary btn-rename-headless" disabled={false}><i className="fa fa-edit mx-1"></i></button>
                                        <button onClick={(e) => cancelRenameHeadlessGateway(e, markerRec)} className="btn btn-sm btn-warning cancel-rename-headless hide btn-rounded-right"><i className="fa fa-arrow-right"></i></button>
                                        <button onClick={() => deleteMarkerPosition(markerRec)} className="btn btn-sm btn-danger hide-while-rename"><i className="fa fa-trash-alt mx-1"></i></button>
                                    </React.Fragment>}
                                </React.Fragment>
                            }
                        </div>
                        :
                        ''
                })}
            </div>
            {!pdfLoaded && <div className="m-2"><Loading>Loading ...</Loading></div>}
            <div id="pdf-doc-container" style={{ visibility: pdfLoaded ? 'visible' : 'hidden' }}>
                {siteplan && siteplan.signed_url && !siteplan.signed_url.includes(".pdf") ?
                    <React.Fragment>
                        <img id="site_img" onClick={annotate} onLoad={onImageload} src={siteplan.signed_url} alt='' style={{ borderTop: "4px", borderLeft: "4px", borderRadius: "4px", position: "absolute", lineHeight: "25px", background: "#E3E4E5", width: "100%", textAlign: "center" }} />
                        <div className="border-rounded-t" style={{ position: "absolute", top: "-35px", lineHeight: "25px", padding: "8px", background: "#E3E4E5", width: "100%", textAlign: "center" }}>
                            <div className="pull-right">
                                <div className="d-inline">
                                    <DropdownButton
                                        className='btn btn-sm dropdown-toggle text-dark py-custom w-50'
                                        onOptionClick={viewHandleChange}
                                        default={viewType === 'gateway' ? 'Gateway' : 'Sensor'}
                                        selected={viewType}
                                        opts={viewDropdown}
                                        field_attr='value'
                                        value_attr='label'
                                    />
                                    {!editMode ?
                                        (CommonUtils.hasPermission('SITESUPT-UI-SITEMAP-MODIFY') ?
                                            <button className="btn btn-sm btn-primary ml-2 w-50" disabled={editMode} onClick={toggleEditMode} data-toggle="tooltip" title="Edit SitePlan">Edit</button>
                                            : '')
                                        :
                                        <>
                                            <button className="btn btn-sm btn-warning ml-2 w-50" disabled={!editMode} onClick={saveMarkerPositions} data-toggle="tooltip" title="Save SitePlan" id="siteplan-save">Save</button>
                                            <button className="btn btn-sm btn-white ml-2 w-50" disabled={!editMode} onClick={cancelEditMode} data-toggle="tooltip" title="Cancel">Cancel</button>
                                            <button className="btn btn-sm btn-primary ml-2 w-50" onClick={clearMarkerPositions} data-toggle="tooltip" title="Clear All Markers">Clear</button>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment> :
                    <Document
                        style={{ overflowX: 'hidden', overflowY: 'auto' }}
                        onLoadSuccess={(obj) => { onPDFLoad(obj) }}
                        options={{ workerSrc: "/pdf.worker.js" }}
                        file={{ url: siteplan.signed_url }}>
                        <Page
                            width={pdfWidth}
                            pageNumber={currPage}>
                            <div className="border-rounded-t" style={{ position: "absolute", top: "-35px", lineHeight: "25px", padding: "8px", background: "#E3E4E5", width: "100%", textAlign: "center" }}>
                                {currPage > 1 && <i className="fa fa-chevron-left mr-2 cursor-pointer" onClick={showPrev} />}
                                {currPage} / {numPages}
                                {currPage < numPages && <i className="ml-2 fa fa-chevron-right cursor-pointer" onClick={showNext} />}
                                <div className="pull-right">
                                    <div className="d-inline">
                                        <DropdownButton
                                            className='btn btn-sm dropdown-toggle text-dark py-custom w-50'
                                            onOptionClick={viewHandleChange}
                                            default={viewType === 'gateway' ? 'Gateway' : 'Sensor'}
                                            selected={viewType}
                                            opts={viewDropdown}
                                            field_attr='value'
                                            value_attr='label'
                                        />
                                        {!editMode ?
                                            (CommonUtils.hasPermission('SITESUPT-UI-SITEMAP-MODIFY') ?
                                                <button className="btn btn-sm btn-primary ml-2 w-50" disabled={editMode} onClick={toggleEditMode} data-toggle="tooltip" title="Edit SitePlan">Edit</button>
                                                : '')
                                            :
                                            <>
                                                <button className="btn btn-sm btn-warning ml-2 w-50" disabled={!editMode} onClick={saveMarkerPositions} data-toggle="tooltip" title="Save SitePlan" id="siteplan-save">Save</button>
                                                <button className="btn btn-sm btn-white ml-2 w-50" disabled={!editMode} onClick={cancelEditMode} data-toggle="tooltip" title="Cancel">Cancel</button>
                                                <button className="btn btn-sm btn-primary ml-2 w-50" onClick={clearMarkerPositions} data-toggle="tooltip" title="Clear All Markers">Clear</button>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Page>
                    </Document>
                }
            </div>
            <br />
        </React.Fragment>
    )
}

export default PDFAnnotate;